angular.module('picmonicng').controller('MySubscriptionsProductAccessController', [
  '$scope',
  'User',
  'UserService',
  'MarketOptionsConfig',
  '$modal',
  '$http',
  function ($scope, User, UserService, MarketOptionsConfig, $modal, $http) {
    $scope.loading = true;
    $scope.UserService = UserService;
    $scope.MarketOptionsConfig = MarketOptionsConfig;
    var now = new Date();
    now.setHours(4 - now.getTimezoneOffset() / 60);
    now.setMinutes(59);
    now.setSeconds(59);
    now.setMilliseconds(999);
    $scope.now = now.getTime();
    User.product_access(function (data) {
      $scope.products = data;
      $scope.loading = false;
      $scope.$emit('endInteraction');
    });

    $scope.cancel = function (product) {
      if (product.mode === 'cancel') {
        product.cancelVisible = false;
        product.mode = '';
        return;
      }
      if (product.promo_code === 'cancellation_special') {
        product.cancelVisible = true;
        product.mode = 'cancel';
        return;
      }

      var modal = $modal.open({
        templateUrl: '/templates/modals/cancel-offer.html',
        size: 'lg',
        backdrop: true,
        controller: [
          '$scope',
          function ($scope) {
            $scope.continue = function () {
              $http.post('/api/v3/orders/' + product.user_order_id + '/apply_cancel_deal');
              $scope.completed = true;
            };
          },
        ],
      });

      modal.result
        .then(function (a) {
          User.product_access(function (data) {
            $scope.products = data;
          });
        })
        .catch(function () {
          product.cancelVisible = true;
          product.mode = 'cancel';
        });
    };
  },
]);
